import React from "react";
import { NavWrap } from "../ShopForTyres";
import CollectKyc from "./CollectKyc";
import "./customers.css";
import CustomersTable from "./CustomersTable";
import { useSelector } from "react-redux";

const Customers = () => {
  const customers_count = useSelector((state) => state?.admin?.customers?.data?.length ?? 0);

  return (
    <NavWrap>
      <div className="customers showTyresFilters admin">
        <div className="head">
          <h3>Customers {customers_count ? `(${customers_count})` : null}</h3>
        </div>
        <CustomersTable />
        <CollectKyc />
      </div>
    </NavWrap>
  );
};

export default Customers;
